import script from "./CarritoViewStore.vue?vue&type=script&setup=true&lang=js"
export * from "./CarritoViewStore.vue?vue&type=script&setup=true&lang=js"

import "./CarritoViewStore.vue?vue&type=style&index=0&id=2991f9a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2991f9a1"]])

export default __exports__